import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Cookies from 'universal-cookie';
import Teaser from '../components/Teaser';
import Templatesets from '../components/Templatesets';
import VideoBlock from '../components/VideoBlock';
import FeaturesCloud from '../components/FeaturesCloud';
import Customers from '../components/Customers';
import Partners from '../components/Partners';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import Consent from "../components/Consent";

import '../components/all.sass';


const IndexPage = ({ pageContext: { locale }, ...props }) => {

  const { node: data } = props.data.homePageData.edges[0];
  const cookies = new Cookies();

  if (typeof window !== 'undefined') {
    const browserLanguage = window.navigator.language;

    const timestamp = new Date().getTime();
    const expire = timestamp + (60 * 60 * 24 * 1000 * 1);
    const expireDate = new Date(expire);

    if (browserLanguage.startsWith('de') && !cookies.get('lang')) {
      cookies.set('lang', 'de', { path: '/', expires: expireDate });
      console.log(browserLanguage, cookies.get('lang'), data);
      if (locale !== cookies.get('lang')) {
        console.log('im here');
        navigate('/de/');
      }
    } else if (!browserLanguage.startsWith('de') && !cookies.get('lang')) {
      cookies.set('lang', 'en', { path: '/' });
      if (locale !== cookies.get('lang')) {
        console.log('im here en');
        navigate('/');
      }
    }
  }
  return (
    <div>
      <Helmet>
        <html id="startpage" lang={locale === 'en' ? 'en' : 'de'} />
        <title>
          {
            locale === 'en' ?
              'presono - the presentation tool for professionals' :
              'presono - Die Präsentationssoftware für Profis'
          }
        </title>
        <meta
          name="description"
          content={
            locale === 'en' ?
              'The next generation of presentation begins now. Presono provides you with a flexible presentation stage and equips you with props to make your visions and ideas uniquely visible and inspire your customers.' :
              'Die nächste Generation der Präsentation beginnt jetzt. Presono stellt Ihnen eine flexible Präsentationsbühne zur Verfügung und stattet Sie mit Requisiten aus, damit Sie Ihre Visionen und Ideen einzigartig sichtbar machen und Ihre Kunden begeistern können.'
          }
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/img/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          href="/img/favicon.ico"
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href="/img/favicon.ico"
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href="/img/logo.svg"
          color="#ff4400"
        />
        <meta name="theme-color" content="#fff" />
        <meta property="og:url" content="/" />
        <meta name="facebook-domain-verification" content="fjngyws05maj4aclkk1k7pllybxboq" />
      </Helmet>

      <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />

      <Teaser header={data.frontmatter} locale={locale} />

      <Templatesets templatesets={data.frontmatter} locale={locale} />

      <VideoBlock videoblock={data.frontmatter} locale={locale} />

      <FeaturesCloud features={data.frontmatter} locale={locale} />

      <section className="headliner starfield t2 b2">
        <div className="container">
          <div className="column">
            <ReactMarkdown source={ data.frontmatter.customersHeadline } />
            <p>
              {data.frontmatter.customersHeadlineSubtext}
            </p>
          </div>
        </div>
      </section>

      <Customers customers={data.frontmatter} locale={locale} />
      <section className="headliner starfield t1 b1">
        <div className="container">
          <div className="column">
            <ReactMarkdown source={ data.frontmatter.partnersHeadline } />
            <p>
              {data.frontmatter.partnersHeadlineSubtext}
            </p>
          </div>
        </div>
      </section>
      <Partners partners={data.frontmatter} locale={locale} />
      <Newsletter newsletter={data.frontmatter} locale={locale} />
      <Footer locale={locale} />
    </div>
  );
};

export default IndexPage;

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export const pageQuery = graphql`
query HomeContent($locale: String) {
  homePageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_home"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          headline
          subtext
          buttonText
          headlineCarousel {
            carouselImage {
              name
              relativePath
            }
            carouselVideoWebm {
              name
              relativePath
            }
            carouselVideoMp {
              name
              relativePath
            }
            carouselHeadline
            carouselSubtext
            carouselButtonText
            carouselButtonLink
          }
          aside1
          aside2
          aside3
          aside4
          aside1Image {
            name
            relativePath
          }
          aside2Image {
            name
            relativePath
          }
          aside3Image {
            name
            relativePath
          }
          aside4Image {
            name
            relativePath
          }
          templatesetsHeadline
          templatesetsHeadlineSubtext
          videoblockHeadline
          videoblockHeadlineSubtext
          featureCloud1Button
          featureCloud1Headline
          featureCloud1Subtext
          featureCloud2Button
          featureCloud2Headline
          featureCloud2Subtext
          featureCloud3Button
          featureCloud3Headline
          featureCloud3Subtext
          featureCloud4Button
          featureCloud4Headline
          featureCloud4Subtext
          featureCloud5Button
          featureCloud5Headline
          featureCloud5Subtext
          featureCloud6Button
          featureCloud6Headline
          featureCloud6Subtext
          featureCloud7Button
          featureCloud7Headline
          featureCloud7Subtext
          featureCloud8Button
          featureCloud8Headline
          featureCloud8Subtext
          featuresHeadline
          featuresHeadlineSubtext
          feature1Text
          feature1Image {
            name
            relativePath
          }
          feature2Text
          feature2Image {
            name
            relativePath
            }
          feature3Text
          feature3Image {
            name
            relativePath
            }
          featuresButton
          customersHeadline
          customersHeadlineSubtext
          customer1Headline
          customer1Text
          customer1Image {
            name
            relativePath
          }
          customer2Headline
          customer2Text
          customer2Image {
            name
            relativePath
          }
          customer3Headline
          customer3Text
          customer3Image {
            name
            relativePath
          }
          customersButton
          partnersHeadline
          partnersHeadlineSubtext
          partnersButton
          awsPartner
          awsPartnerSubtext
          langSwitch
        }
      }
    }
  }
}
`;
